<template>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19 14L12.3536 7.35355C12.1583 7.15829 11.8417 7.15829 11.6464 7.35355L5 14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>
</template>

<script>
export default {
    name: 'SVGArrowUp',
};
</script>

<style scoped>

</style>